<div
    [fiVariationBase]="'fi-modal-footer'"
    [fiVariation]="variation">
    <ng-content></ng-content>
</div>
